import keyMirror from 'keymirror';

const AccountUpdateTypes = keyMirror({
  CHANGE_SELECTED_CLIENT: null,
  UPDATE_ACCOUNT_INFO: null
});

export default AccountUpdateTypes;



// WEBPACK FOOTER //
// ./src/apps/Account/actions/AccountUpdateTypes.js